module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"wh100 table table-0-100\">\n	<div>\n		<div class=\"gl-report__header\">\n			<div class=\"gl-report__title\">\n				")
    ; __append(escapeFn( widget.getTitle() ))
    ; __append("\n			</div>\n\n			<div name=\"parameters\"></div>\n		</div>\n	</div>\n\n	<div>\n		<div class=\"gl-report__body\">\n			<div name=\"data\" class=\"wh100\">\n			</div>\n		</div>\n	</div>\n</div>")
  }
  return __output.join("");

}